<template>
  <div v-if="!isAgree">
    <b-row>
      <b-col sm="12" lg="3" md="2"></b-col>
      <b-col sm="12" lg="6" md="8">
        <b-card no-body>
          <b-card-header class="bg-white p-4">
            <h5 class="text-center text-wrap mt-0">
              <b>
                {{ $t("register.text.text1") }}
                <br />
              </b>
            </h5>
          </b-card-header>
          <div
            style="text-align: justify; padding: 21px; overflow-y: scroll; height: 60vh"
            v-if="getTitleByCode()"
          >
            <div v-html="getTitleByCode('rules')[$localeKey()]"></div>
          </div>
          <b-card-footer class="bg-white">
            <b-row class="p-3">
              <b-form-checkbox size="lg" v-model="isAgreeCheckbox">
                <p style="font-size: 17px" class="p-0">
                  {{ $t("login.oferta") }}
                </p>
              </b-form-checkbox>
            </b-row>
            <b-row class="mt-7 p-0">
              <b-col lg="4" sm="2"></b-col>
              <b-col class="p-0 pr-2" xs="5">
                <b-button
                  style="padding: 10px"
                  variant="outline-danger"
                  block
                  @click="$router.push('/')"
                  >{{ $t("actions.cancel") }}
                </b-button>
              </b-col>
              <b-col class="p-0" xs="5">
                <b-button
                  style="padding: 10px"
                  variant="primary"
                  block
                  :disabled="!isAgreeCheckbox"
                  @click="toRegister"
                  >{{ $t("register.title") }}
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col sm="12" lg="3" md="2"></b-col>
    </b-row>
  </div>
  <div v-else style="border-radius: 10px">
    <b-row>
      <b-col sm="12" lg="3" md="2"></b-col>
      <b-col sm="12" lg="6" md="8">
        <b-card no-body v-if="!isSendMessage" style="border: none">
          <b-card-header class="bg-white p-4">
            <h5 class="text-wrap mt-0">
              <b>
                <h2>
                  <strong class="text-primary">{{ $t("register.title") }}</strong>
                </h2>
              </b>
            </h5>
          </b-card-header>

          <div class="login-form login-signin">
            <!--begin::Form-->
            <div class="p-5">
              <b-row>
                <b-col lg="4" xs="12">
                  <label class="mt-lg-1">
                    {{ $t("register.passport") }}
                  </label>
                </b-col>
                <b-col lg="8" xs="12">
                  <b-row>
                    <b-col cols="5" class="pr-0">
                      <vue-select
                        class="style-ch"
                        @search="fetchOptions"
                        v-model="$v.form.passportSerialId.$model"
                        :options="passportSeriaList"
                        label="title"
                      />
                    </b-col>
                    <b-col cols="7" class="pl-1">
                      <b-form-group label class="mb-2">
                        <b-form-input
                          class="form-control form-control-solid h-auto p-2"
                          v-model="$v.form.passportNumber.$model"
                          v-mask="'#######'"
                          :state="validateState('passportNumber')"
                          aria-describedby="input-passportNumber-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback
                          class="f"
                          id="input-passportNumber-live-feedback"
                          >{{ $t("error.name_error") }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="4" xs="12">
                  <label class="mt-2">
                    {{ $t("register.username") }}
                  </label>
                </b-col>
                <b-col lg="8" xs="12">
                  <b-form-group label class="mb-2">
                    <b-form-input
                      class="form-control form-control-solid h-auto p-2"
                      v-model.trim="$v.form.username.$model"
                      :state="validateState('username')"
                      aria-describedby="input-username-live-feedback"
                    ></b-form-input>
                    <div
                      v-if="errorUsername"
                      style="width: 300px; font-size: 11px; color: red"
                      class="text-wrap"
                    >
                      {{ $t("actions.usernameError") }}
                    </div>
                    <b-form-invalid-feedback
                      v-if="!user_kirill && !user_kirill_lower"
                      class="f"
                      id="input-username-live-feedback"
                      >{{ $t("error.name_error") }}
                    </b-form-invalid-feedback>
                    <div
                      v-if="user_kirill || user_kirill_lower"
                      style="font-size: 10px !important; margin-top: 0.16rem"
                      class="text-wrap text-danger"
                    >
                      {{ $t("secury.msg8") }}
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="4" xs="12">
                  <label class="mt-2">{{ $t("register.password") }}</label>
                </b-col>
                <b-col lg="8" xs="12">
                  <b-input-group>
                    <b-form-input
                      id="password"
                      :type="show2 ? 'text' : 'password'"
                      class="form-control form-control-solid h-auto p-2"
                      v-model="$v.form.password.$model"
                      aria-describedby="input-password-live-feedback"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button
                        :disabled="!form.password"
                        variant="primary"
                        @click="show2 = !show2"
                        ><i class="fa" :class="show2 ? 'fa-eye-slash' : 'fa-eye'"></i
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div>
                    <password-meter
                      v-if="!has_krill && !has_krill_lower"
                      :password="form.password"
                      @score="onScore"
                    />
                    <div
                      v-if="!has_krill && !has_krill_lower"
                      style="font-size: 11px !important"
                      class="text-wrap"
                    >
                      {{ messagePSWD }}
                    </div>
                    <div
                      v-if="has_krill || has_krill_lower"
                      style="font-size: 11px !important"
                      class="text-wrap text-danger"
                    >
                      {{ $t("secury.msg8") }}
                    </div>
                    <b-form-invalid-feedback
                      id="input-password-live-feedback"
                      class="f"
                    ></b-form-invalid-feedback>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="4" xs="12">
                  <label>
                    {{ $t("register.confirmPassword") }}
                  </label>
                </b-col>
                <b-col lg="8" xs="12">
                  <b-input-group>
                    <b-form-input
                      :type="show ? 'text' : 'password'"
                      id="example-input-2"
                      name="example-input-2"
                      v-model="$v.form.passwordConfirm.$model"
                      :state="validateState('passwordConfirm')"
                      aria-describedby="input-c-live-feedback"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button
                        :disabled="!form.passwordConfirm"
                        variant="primary"
                        @click="show = !show"
                        ><i class="fa" :class="show ? 'fa-eye-slash' : 'fa-eye'"></i
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback class="f" id="input-c-live-feedback"
                    >{{ $t("secury.successNoPswdSecury") }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <!--end::Action-->
            </div>
            <!--end::Form-->
          </div>
          <b-card-footer class="p-3 bg-white">
            <!--begin::Action-->
            <b-row class="mt-7 p-0">
              <b-col lg="6" xs="5"></b-col>
              <b-col xs="3" lg="3">
                <b-button
                  block
                  class="mb-2"
                  style="padding: 10px"
                  variant="outline-primary"
                  @click="
                    $router.push({
                      path: '/',
                      query: {
                        page: 'register',
                      },
                    })
                  "
                >
                  <i class="fa fa-arrow-left"></i>
                  {{ $t("actions.back") }}
                </b-button>
              </b-col>
              <b-col xs="6" lg="3">
                <b-button
                  style="padding: 10px"
                  variant="primary"
                  block
                  @click.prevent="onSubmitCode"
                >
                  {{ $t("register.next") }}
                  <i class="fa fa-arrow-right"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
          <!--end::Signup-->
        </b-card>

        <b-card style="border: none" no-body v-if="isSendMessage">
          <div>
            <div ref="sendRef" @submit.prevent="confirmationCode">
              <b-card-header class="p-4 bg-white">
                <b-row>
                  <b-col cols="12">
                    <label class="mt-lg-1">
                      <p style="font-size: 25px">
                        {{ $t("login.verifiyCodeWhere") }}
                      </p>
                    </label>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-radio
                        size="lg"
                        v-model="selectSendCode"
                        name="some-radios"
                        value="email"
                      >
                        <p style="font-size: 15px" class="ml-2 mt-1">
                          {{ $t("register.email") }}
                        </p>
                      </b-form-radio>
                      <b-form-radio
                        size="lg"
                        v-model="selectSendCode"
                        name="some-radios"
                        value="phone"
                      >
                        <p style="font-size: 15px" class="ml-2 mt-1">
                          {{ $t("register.phone") }}
                        </p>
                      </b-form-radio>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-header>
              <div class="pl-5 pr-5">
                <b-row class="mt-3 text-center">
                  <b-row
                    v-if="selectSendCode == 'email'"
                    style="padding: 10px; width: 100%"
                  >
                    <b-col></b-col>
                    <b-col lg="9" xs="12">
                      <h5 class="text-center">
                        {{ $t("actions.enteredEmail") }}
                      </h5>
                      <b-form-group label class="mb-2">
                        <b-form-input
                          class="form-control form-control-solid h-auto p-3"
                          v-model="$v.email.$model"
                          :state="!$v.email.$error"
                          aria-describedby="input-email-live-feedback"
                        ></b-form-input>

                        <b-form-invalid-feedback class="f" id="input-email-live-feedback"
                          >Email is required and a valid email address.
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col></b-col>
                  </b-row>
                  <b-row
                    v-else-if="selectSendCode == 'phone'"
                    style="padding: 10px; margin-bottom: 20px; width: 100%"
                  >
                    <b-col></b-col>
                    <b-col xs="12" lg="9">
                      <h5 class="text-center">
                        {{ $t("actions.enterPhone") }}
                      </h5>
                      <b-form-group label class="mb-2">
                        <b-form-input
                          class="form-control form-control-solid h-auto p-3"
                          v-model="$v.phoneForm.$model"
                          :state="!$v.phoneForm.$error"
                          aria-describedby="input-email-live-feedback"
                          v-mask="'998 ## ### ## ##'"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col></b-col>
                  </b-row>
                </b-row>
              </div>
            </div>
          </div>
          <div v-if="openConfirmPage">
            <Confirmation
              @back="backFromConfirmation"
              @resend="confirmationCode"
            ></Confirmation>
          </div>
          <b-card-footer class="p-0 bg-white" v-else>
            <div class="p-4">
              <b-row class="mt-7 p-0">
                <b-col xs="12" lg="4"></b-col>
                <b-col lg="4" xs="12" class="p-0 pr-2">
                  <b-button
                    class="p-2 mb-2"
                    variant="outline-primary"
                    block
                    @click="isSendMessageBtn"
                  >
                    <i class="fa fa-arrow-left"></i>
                    {{ $t("actions.back") }}
                  </b-button>
                </b-col>
                <b-col lg="4" xs="12" class="p-0">
                  <b-button class="p-2" variant="primary" block @click="confirmationCode">
                    {{ $t("register.getconfirmCode") }}
                    <i class="fa fa-paper-plane"></i>
                  </b-button>
                </b-col>
                <b-col></b-col>
              </b-row>
            </div>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col sm="12" lg="3" md="2"></b-col>
    </b-row>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.r {
  min-width: 55vh !important;
}
</style>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import passwordMeter from "vue-simple-password-meter";
import { validationMixin } from "vuelidate";

import {
  email,
  required,
  minLength,
  maxLength,
  sameAs,
  integer,
} from "vuelidate/lib/validators";
import Confirmation from "./confirmation";
import VacancyService from "@/services/vacancy.service";
import { bus } from "@/main";
import moment from "moment";
import i18n from "@/core/plugins/vue-i18n";
import { UserService } from "@/services/user.service";
import { hasNotCrilic } from "@/core/util/validators.js";
export default {
  mixins: [validationMixin],
  name: "registration",
  components: {
    Confirmation,
    passwordMeter,
  },
  async created() {
    await this.getpassportSeriaList(this.params);
  },
  data() {
    return {
      user_kirill: false,
      user_kirill_lower: false,
      show2: false,
      show: false,
      errorUsername: false,
      messagePSWD: "",
      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_krill: false,
      has_krill_lower: false,
      has_special: false,
      max: 100,
      score: null,
      selected: "",
      openConfirmPage: false,
      selectSendCode: "email",
      isAgreeCheckbox: false,
      form: {
        username: "",
        passportNumber: "",
        password: "",
        passwordConfirm: "",
        passportSerialId: null,
      },

      email: null,
      phoneForm: null,
      search: {
        title: null,
      },
      isSendMessage: false,
    };
  },
  validations: {
    email: {
      email,
      required,
    },
    phoneForm: {
      required,
    },
    form: {
      username: {
        required,
        minLength: minLength(3),
        hasNotCrilic,
      },
      passportNumber: {
        required,
        integer,
        minLength: minLength(7),
        maxLength: maxLength(7),
      },

      passportSerialId: {
        required,
      },
      password: {
        required,
        minLength: minLength(8),
        hasNotCrilic,
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs("password"),
      },
    },
  },
  methods: {
    userMSG() {
      if (this.form.username.length > 0) {
        if (this.user_kirill || this.user_kirill_lower) {
          return "" + this.$t("onlyLotin");
        } else return "";
      } else return "" + this.$t("error.name_error");
    },
    showPswdNew() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    showPswdConfirm() {
      // var x = document.getElementById("example-input-2");
      // if (x.type === "password") {
      //   x.type = "text";
      // } else {
      //   x.type = "password";
      // }
    },
    isSendMessageBtn() {
      this.openConfirmPage = false;
      this.isSendMessage = false;
    },
    backFromConfirmation() {
      this.openConfirmPage = false;
      this.isSendMessage = false;
    },
    async confirmationCode() {
      if (this.selectSendCode == "email") {
        let error = this.$v.email.$touch();
        if (!error) {
          this.$nextTick(() => {
            this.openConfirmPage = true;
          });
          let res = await this.register({
            email: this.email,
            password: this.form.password,
            username: this.form.username,
            passportNumber: this.form.passportNumber,
            passportSerialTitle: this.form.passportSerialId,
          });

          if (!res) {
            // this.$toast.error(this.$t("error.login_error"));
          }
        }
      } else if (this.selectSendCode == "phone") {
        let errorPhone = this.$v.phoneForm.$touch();
        if (!errorPhone) {
          const phonelist = this.phoneForm.split(" ");
          const phone =
            phonelist[0] + phonelist[1] + phonelist[2] + phonelist[3] + phonelist[4];
          this.$nextTick(() => {
            this.openConfirmPage = true;
          });
          let res = await this.registerPhone({
            password: this.form.password,
            username: this.form.username,
            phone: phone,
            passportNumber: this.form.passportNumber,
            passportSerialTitle: this.form.passportSerialId,
          });
          if (!res) {
            // this.$toast.error(this.$t("error.login_error"));
          }
        }
      }
    },
    onScore({ score, strength }) {
      this.score = score;
      this.has_minimum_lenth = this.form.password.length >= 8;
      this.has_number = /\d/.test(this.form.password);
      this.has_lowercsae = /[a-z]/.test(this.form.password);
      this.has_uppercase = /[A-Z]/.test(this.form.password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.form.password);
      this.messagePSWD = " " + this.$t("secury.msg1");
      this.has_krill = /[А-Я]/.test(this.form.password);
      this.has_krill = /[а-я]/.test(this.form.password);
      if (this.has_krill) this.score = 1;

      if (this.has_minimum_lenth === false) {
        this.messagePSWD += " " + this.$t("secury.msg2");
      }
      if (this.has_number === false) {
        this.messagePSWD += " " + this.$t("secury.msg3");
      }
      if (this.has_lowercsae === false) {
        this.messagePSWD += " " + this.$t("secury.msg4");
      }
      if (this.has_uppercase === false) {
        this.messagePSWD += " " + this.$t("secury.msg5");
      }
      if (this.has_special === false) {
        this.messagePSWD += " " + this.$t("secury.msg6");
      }
      this.messagePSWD += " " + this.$t("secury.msg7");

      if (
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth
      ) {
        this.messagePSWD = this.$t("secury.successPswdSecury");
      }

      if (!score) {
        this.messagePSWD = "";
        this.has_minimum_lenth = false;
        this.has_number = false;
        this.has_lowercsae = false;
        this.has_uppercase = false;
        this.has_special = false;
      }
    },
    ...mapMutations("auth", ["setNextRegistr"]),
    ...mapActions("auth", [
      "register",
      "register",
      "registerPhone",
      "nextRegister",
      "nextRegisterBack",
      "confirmBack",
    ]),
    ...mapActions("passportSeria", { getpassportSeriaList: "getList" }),
    getusernameAlready() {
      return this.$i18n.locale === "lt"
        ? "Ushbu foydalanuvchi nomi allaqachon mavjud"
        : this.$i18n.locale === "ru"
        ? "nameRu"
        : this.$i18n.locale === "uz"
        ? "nameUz"
        : "";
    },
    nextPage() {
      let res = null;
      res = this.nextRegister({
        id: this.form.passportSerialId.id,
        passportNumber: this.form.passportNumber,
        title: this.form.passportSerialId.title,
      });
    },

    async fetchOptions(search, loading) {
      this.search.title = search;
      await this.getpassportSeriaList(this.params);
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    toRegister() {
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          agree: true,
        },
      });
    },
    checkValidity() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return true;
      } else {
        return false;
      }
    },
    checkPswd() {
      let checkPswdResult = false;

      this.has_minimum_lenth = this.form.password.length >= 8;
      this.has_number = /\d/.test(this.form.password);
      this.has_lowercsae = /[a-z]/.test(this.form.password);
      this.has_uppercase = /[A-Z]/.test(this.form.password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.form.password);

      if (
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth
      ) {
        checkPswdResult = true;
      } else {
        checkPswdResult = false;
        this.$toast.error(this.$t("secury.successNoPswdSecury"));
      }
      return checkPswdResult;
    },
    onSubmitCode() {
      let error = this.checkValidity();
      let checkPswdResult = this.checkPswd();

      if (checkPswdResult && !error && !this.errorUsername) {
        UserService.nextRegister({
          passportSerialId: this.form.passportSerialId.id,
          passportSerialTitle: this.form.passportSerialId.title,
          passportNumber: this.form.passportNumber,
          username: this.form.username,
          password: this.form.password,
          confirmPassword: this.form.passwordConfirm,
        })
          .then((res) => {
            this.$nextTick(() => {
              if (res.data == "success" || res.data.passport !== "") {
                this.$nextTick(() => {
                  this.isSendMessage = true;
                });
              } else if (res.data.email) {
                this.$nextTick(() => {
                  this.isSendMessage = true;
                });
              } else if (res.data == "error") {
                this.$toast.info(res.data);
              } else if (res.data == "This username already exists...") {
                this.$toast.info(
                  this.$i18n.locale === "lt"
                    ? "Ushbu foydalanuvchi nomi allaqachon mavjud"
                    : this.$i18n.locale === "ru"
                    ? "Такое имя пользователя уже существует"
                    : this.$i18n.locale === "uz"
                    ? "Ушбу фойдаланувчи номи аллақачон мавжуд"
                    : ""
                );
              }
            });
          })
          .catch((e) => {
            this.$toast.error(e.request.response);
          });
      }
    },
  },
  computed: {
    ...mapGetters("title", ["getTitleByCode"]),
    ...mapState("passportSeria", { passportSeriaList: "list" }),

    isAgree() {
      return this.$route.query.agree;
    },
    params() {
      return {
        order: "",
        page: 0,
        limit: 100,
        type: "",
        search: this.search,
      };
    },
  },
  watch: {
    has_krill(e) {
      if (e) {
        this.has_minimum_lenth = false;
        this.has_number = false;
        this.has_lowercsae = false;
        this.has_uppercase = false;
        this.has_special = false;
      }
    },
    has_krill_lower() {
      this.has_minimum_lenth = false;
      this.has_number = false;
      this.has_lowercsae = false;
      this.has_uppercase = false;
      this.has_special = false;
    },
    selectSendCode: {
      handler(v) {
        if (v == "email") {
          this.openConfirmPage = false;
          this.phoneForm = null;
        } else {
          this.email = null;
          this.openConfirmPage = false;
        }
      },
    },
    isAgree: {
      handler(v) {
        if (!v) {
          this.$store.commit("auth/setNextRegistr", "");
        }
      },
    },
    "form.password": async function (newValue) {
      this.has_krill = /[А-Я]/.test(this.form.password);
      this.has_krill_lower = /[а-я]/.test(this.form.password);
      if (this.form.password === "") {
        this.messagePSWD = this.$t("secury.fullMsg");
        this.has_minimum_lenth = false;
        this.has_number = false;
        this.has_lowercsae = false;
        this.has_uppercase = false;
        this.has_special = false;
        this.has_krill = false;
      }
    },
    "form.username": {
      handler(value) {
        this.user_kirill = /[А-Я]/.test(this.form.username);
        this.user_kirill_lower = /[а-я]/.test(this.form.username);
        let bool = false;
        for (let i = 0; i < value.length && !bool; i++) {
          if (value.charAt(i) == " ") {
            this.errorUsername = true;
            bool = true;
          } else {
            this.errorUsername = false;
            bool = false;
          }
        }
      },
    },
    user_kirill(e) {},
    user_kirill_lower(e) {},
  },
};
</script>
<style>
.po-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 5px;
  margin-top: 8px;
}

.po-password-strength-bar.risky {
  background-color: #f95e68;
  width: 10%;
}

.po-password-strength-bar.guessable {
  background-color: #fb964d;
  width: 32.5%;
}

.po-password-strength-bar.weak {
  background-color: #fdd244;
  width: 55%;
}

.po-password-strength-bar.safe {
  background-color: #b0dc53;
  width: 77.5%;
}

.po-password-strength-bar.secure {
  background-color: #35cc62;
  width: 100%;
}

.style-ch .vs__search::placeholder,
.style-ch .vs__dropdown-toggle,
.style-ch .vs__dropdown-menu {
  background: #fff;
  border: 0px solid #e5eaee;
  border: 1px solid #ced4da;
  color: #394066;
}
.style-ch .vs__selected-options {
  min-height: 37px;
}

.b-table-sticky-header > .table.b-table > thead > tr > th {
  z-index: 1 !important;
}

.f {
  font-size: 9px !important;
}
</style>
